import axios from './axiosConfig';
import { ICoupon } from '../types/coupon';
import { ICouponStats } from '../types/couponStats';
import { environment } from '../config/environment';

export const couponService = {
  saveCoupon: async (
    couponId: string | undefined,
    notificationType: string,
    triggerType: string,
    couponCode: string,
    notificationText: string,
    notificationUrl: string | undefined,
    description: string,
    imageUrl: string,
    dateStart: string,
    dateEnd: string,
    maximumRedemptions: number,
    maxCount: number,
    discountType: string,
    discountValue: number,
    accountNumbers: string,
    productCodes: string,
    isScheduledTask: number,
    scheduledTaskStart: string | null | undefined
  ): Promise<ICoupon> => {
    const reqBody = {
      couponId,
      notificationType,
      triggerType,
      couponCode,
      notificationText,
      notificationUrl,
      description,
      imageUrl,
      dateStart,
      dateEnd,
      maximumRedemptions,
      maxCount,
      discountType,
      discountValue,
      accountNumbers,
      productCodes,
      isScheduledTask,
      scheduledTaskStart,
    };

    const response = await axios.post<ICoupon>(
      `${environment.apiUrl}coupon`,
      reqBody
    );
    return response.data;
  },

  saveNotification: async (
    couponId: string | undefined,
    notificationType: string,
    triggerType: string,
    notificationText: string,
    notificationUrl: string | undefined,
    description: string,
    imageUrl: string,
    maxCount: number,
    accountNumbers: string,
    isScheduledTask: number,
    scheduledTaskStart: string | null | undefined
  ): Promise<ICoupon> => {
    const reqBody = {
      couponId,
      notificationType,
      triggerType,
      notificationText,
      notificationUrl,
      description,
      imageUrl,
      maxCount,
      accountNumbers,
      isScheduledTask,
      scheduledTaskStart,
    };

    const response = await axios.post<ICoupon>(
      `${environment.apiUrl}coupon`,
      reqBody
    );
    return response.data;
  },

  getStats: async (couponId: string, notificationType: string): Promise<ICouponStats[]> => {
    const response = await axios.get<ICouponStats[]>(
      `${environment.apiUrl}report/stats/json?notification_type=${notificationType}&couponId=${couponId}`
    );
    return response.data;
  },
};
